import { createSlice } from '@reduxjs/toolkit';

import { initFailed, initSucceeded } from '../../actions/cruiseListActions';

// Both outcomes carry the same labels, which is why this slice reads two shared actions rather
// than owning one.
const labelsSlice = createSlice({
  name: 'labels',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (_state, action) => action.payload.labels)
      .addCase(initFailed, (_state, action) => action.payload.labels);
  },
});

export default labelsSlice.reducer;
